export class CertPersonEntity {
    id:number;
    certificateId:number;
    personId:number;
    
    constructor() { }
}